import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Avatar } from '@shared/components/avatar/avatar';
import { AvatarSize } from '@shared/components/avatar/avatar.types';
import { DynamicText } from '@shared/components/dynamic-text/dynamic-text';
import { SvgIcon } from '@shared/components/svg-icon/svg-icon';
import { type DynamicAction } from '@shared/registry';

import { type RowButtonConfig } from './row-button.types';

@Component({
  selector: 'app-row-button',
  templateUrl: './row-button.html',
  imports: [DynamicText, SvgIcon, Avatar],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RowButton {
  readonly config = input.required<RowButtonConfig>();
  readonly disabled = input<boolean>(false);

  readonly action = output<DynamicAction>();

  protected readonly AvatarSize = AvatarSize;

  protected onClick(): void {
    const action = this.config().action;
    if (action) {
      this.action.emit(action);
    }
  }
}
